import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isDeltasharesItem = objectOf({
  app_group_id: string,
  sharing_id: string,
  tier: maybe(number, true),
});

export const isGetDeltasharesResult = objectOf({
  datashares: arrayOf(isDeltasharesItem),
  used_tier1_entitlements: maybe(number, true),
  used_tier2_entitlements: maybe(number, true),
  used_tier3_entitlements: maybe(number, true),
  total_tier1_entitlements: maybe(number, true),
  total_tier2_entitlements: maybe(number, true),
  total_tier3_entitlements: maybe(number, true),
  entitlement_counts_unavailable: maybe(boolean, true),
});

export const isMutateDeltasharesResult = objectOf({
  status: number,
  message: string,
  warn: maybe(string, true),
  warn_header: maybe(string, true),
});
